import { climateRatios } from './climateRatios';
import { mapRatioTable } from './domain';
import type { Perimeter, PlanBuilding, RatioTable, Referential } from './types';

// Arrêté du 26/10/2010, annexe I : https://www.legifrance.gouv.fr/loda/article_lc/LEGIARTI000022961560
// Le classeur utilisateur distingue IDF de H1a : ses blocs IDF priment pour les départements franciliens du jeu.
const DEPARTMENTS: Record<string, { regulatoryZone: string; workbookZone: string }> = {
  '06': { regulatoryZone: 'H3', workbookZone: 'H3' },
  '33': { regulatoryZone: 'H2c', workbookZone: 'H2c' },
  '35': { regulatoryZone: 'H2a', workbookZone: 'H2a' },
  '67': { regulatoryZone: 'H1b', workbookZone: 'H1b' },
  '93': { regulatoryZone: 'H1a', workbookZone: 'IDF' },
  '94': { regulatoryZone: 'H1a', workbookZone: 'IDF' },
};

export function territoryClimate(perimeter: Perimeter, buildings: PlanBuilding[], referential: Referential) {
  const codes = [...new Set(perimeter.kind === 'communes'
    ? perimeter.communes : buildings.flatMap(b => b.communes))].sort();
  const names = codes.map(code => `${referential.communes.find(c => c.insee === code)?.name ?? code} (${code.slice(0, 2)})`);
  const unknown = codes.filter(code => !DEPARTMENTS[code.slice(0, 2)]);
  const zones = [...new Set(codes.flatMap(code => DEPARTMENTS[code.slice(0, 2)]?.workbookZone ?? []))].sort();
  const zone = codes.length > 0 && unknown.length === 0 && zones.length === 1 ? zones[0] : null;
  const explanation = !codes.length ? 'Aucune commune du périmètre projet sélectionnée.'
    : unknown.length ? `Source indisponible : correspondance climatique non documentée pour ${unknown.join(', ')}.`
      : zones.length > 1 ? `Périmètre multizone (${zones.join(', ')}) : aucun jeu unique initialisé, aucune moyenne ni sélection arbitraire.`
        : `Source : Ratios par zone climatique — ${zone}, déterminée à partir des communes sélectionnées : ${names.join(', ')}.`;
  return { zone, zones, unknown, codes, explanation };
}

export function territoryRatioDefaults(zone: string | null) {
  if (zone) return climateRatios(zone);
  const ratios: RatioTable = { ...mapRatioTable(() => ({ chauffage: null, ecs: null, froid: null })), periodSchema: 'climate2026' };
  return { ratios, degrees: { dju: 2500, djclim: 110 } };
}
